<template>
  <span :class="{ 'value-change': valueChanged }">{{ value }}</span>
</template>

<script>
export default {
  name: "ChangingCounter",
  props: {
    value: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      valueChanged: false,
      previousValue: null,
      isFirstPopulation: true
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (!this.isFirstPopulation && newVal !== oldVal) {
        this.valueChanged = true;
        setTimeout(() => {
          this.valueChanged = false;
        }, 2500);
      }
      if (this.isFirstPopulation) {
        this.isFirstPopulation = false;
      }
      this.previousValue = newVal;
    }
  }
}
</script>

<style scoped>
.value-change {
  animation: highlight-pulse 2.5s ease;
}

@keyframes highlight-pulse {
  0% {
    background-color: transparent;
    transform: scale(1);
  }
  20% {
    background-color: rgba(144, 238, 144, 0.5);
    transform: scale(1.08);
  }
  100% {
    background-color: transparent;
    transform: scale(1);
  }
}
</style>